// ReportHeaderProductivityTotal Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import Util from '../../../lib/util.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'

class ReportHeaderProductivityTotal extends Component {
  static get propTypes () {
    return {
      stat: PropTypes.object
    }
  }

  static get defaultProps () {
    return {
      stat: null
    }
  }

  render () {
    const stat = this.props.stat

    return (
      <div className='report-header-productivitytotal'>
        <h2 className='title'>
          {IntlUtil.convertMessage('report.list.projectHeaderTotal')}
        </h2>
        <div className='content'>
          <div className='totalitem available'>
            <div className='title'>
              {Util.convertMinutesToHour(stat.totalAvailable)}
            </div>
            <div className='label'>
              <IntlMessage ident='report.header.labelAvailable' />
            </div>
          </div>
          <div className='totalitem planned'>
            <div className='title'>
              {Util.convertMinutesToHour(stat.totalPlanned)}
            </div>
            <div className='label'>
              <IntlMessage ident='report.header.labelPlanned' />
            </div>
          </div>
          <div className='totalitem away'>
            <div className='title'>
              {Util.convertMinutesToHour(stat.totalAway)}
            </div>
            <div className='label'>
              <IntlMessage ident='report.header.labelAway' />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ReportHeaderProductivityTotal
